import { useCallback, useEffect, useState } from 'react';

export function useEventErrorHandler() {
  const [error, setError] = useState<string>('');

  useEffect(() => {
    if (error) {
      throw new Error(error);
    }
  }, [error]);

  const handlerError = useCallback((callback: unknown) => {
    try {
      if (typeof callback === 'function') {
        return callback();
      }
    } catch (error) {
      setError(error as string);
    }
  }, []);

  return handlerError;
}
